import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=3d3d7154&scoped=true&"
import script from "./Announcement.vue?vue&type=script&lang=js&"
export * from "./Announcement.vue?vue&type=script&lang=js&"
import style0 from "./Announcement.vue?vue&type=style&index=0&id=3d3d7154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3d7154",
  null
  
)

export default component.exports